import {
	PanelBody,
	__experimentalNumberControl as NumberControl,
	Flex,
	FlexItem,
	Button,
	BaseControl,
} from '@wordpress/components';
import { link, linkOff } from '@wordpress/icons';
import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import InspectorResponsiveLabel from '../inspector-responsive-label';
import { AlphaFourDCss } from '../../functions/Css';
// import { mediaChange } from '../inspector-responsive-label-2';
const InspectorFourDimension = ( props ) => {
	// Local state for borders
	const { label, value, onChange = () => {}, min, max } = props;
	const [ sideTop, setSideTop ] = useState( value?.desktop?.sideTop );
	const [ sideRight, setSideRight ] = useState( value?.desktop?.sideRight );
	const [ sideBottom, setSideBottom ] = useState(
		value?.desktop?.sideBottom
	);
	const [ sideLeft, setSideLeft ] = useState( value?.desktop?.sideLeft );
	const [ isLinked, setIsLinked ] = useState( true );

	const [ currentMedia, setCurrentMedia ] = useState( 'desktop' );
	const [ currentUnit, setCurrentUnit ] = useState( {
		key: 'px',
		name: 'px',
	} );

	const makeUnitObj = ( unit ) => ( {
		key: unit?.key ?? unit,
		name: unit?.name ?? unit,
	} );
	const getUnit = ( unit ) => unit?.key ?? unit;

	const reSet = () => {
		if ( 'function' === typeof onChange ) {
			// console.log("range control", value,props?.defaultAttributes, {...value, ...props?.defaultAttributes} );
			let defaultValue = { ...props?.defaultAttributes };
			setCurrentMedia( 'desktop' );
			setSideTop( defaultValue?.[ 'desktop' ]?.sideTop );
			setSideRight( defaultValue?.[ 'desktop' ]?.sideRight );
			setSideBottom( defaultValue?.[ 'desktop' ]?.sideBottom );
			setSideLeft( defaultValue?.[ 'desktop' ]?.sideLeft );
			setCurrentUnit( () =>
				makeUnitObj( defaultValue?.[ 'desktop' ]?.unit )
			);
			onChange( { ...props?.defaultAttributes } );
		}
	};

	const updateBorders = ( value, side ) => {
		if ( isLinked ) {
			setSideTop( value );
			setSideRight( value );
			setSideBottom( value );
			setSideLeft( value );
		} else {
			if ( side === 'sideTop' ) setSideTop( value );
			if ( side === 'sideRight' ) setSideRight( value );
			if ( side === 'sideBottom' ) setSideBottom( value );
			if ( side === 'sideLeft' ) setSideLeft( value );
		}
	};

	useEffect( () => {
		onChange( {
			...value,
			[ currentMedia ]: {
				...value?.[ currentMedia ],
				sideTop,
				sideRight,
				sideBottom,
				sideLeft,
				unit: getUnit( currentUnit ),
			},
		} );
	}, [ sideTop, sideRight, sideBottom, sideLeft, currentUnit ] );

	useEffect( () => {
		if ( currentMedia in value ) {
			setSideTop( value?.[ currentMedia ]?.sideTop );
			setSideRight( value?.[ currentMedia ]?.sideRight );
			setSideBottom( value?.[ currentMedia ]?.sideBottom );
			setSideLeft( value?.[ currentMedia ]?.sideLeft );
			setCurrentUnit( makeUnitObj( value?.[ currentMedia ]?.unit ) );
		}

		onChange( {
			...value,
			[ currentMedia ]: {
				...value?.[ currentMedia ],
				sideTop,
				sideRight,
				sideBottom,
				sideLeft,
				unit: getUnit( currentUnit ),
			},
		} );

		// mediaChange(currentMedia);
	}, [ currentMedia ] );

	return (
		<BaseControl
			// label={__('Border Width', 'your-text-domain')}
			__nextHasNoMarginBottom
			className={ 'alpha-fourD-control' }
		>
			<InspectorResponsiveLabel
				label={ label ?? 'Default Label' }
				value={ value }
				currentMedia={ currentMedia }
				setCurrentMedia={ setCurrentMedia }
				currentUnit={ currentUnit }
				setCurrentUnit={ setCurrentUnit }
				onReset={ () => reSet() }
				unites={ [ 'px', 'em', '%' ] }
				defaultUnit="px"
			/>
			<Flex
				gap={ 0 }
				className="overflow-hidden justify-stretch"
				align="center"
			>
				{ /* Border Top */ }
				<FlexItem>
					<NumberControl
						value={ sideTop }
						onChange={ ( value ) =>
							updateBorders( value, 'sideTop' )
						}
						min={ min ?? '' }
						max={ max ?? '' }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
						style={ { minWidth: 50 } }
					/>
				</FlexItem>

				{ /* Border Right */ }
				<FlexItem>
					<NumberControl
						value={ sideRight }
						onChange={ ( value ) =>
							updateBorders( value, 'sideRight' )
						}
						min={ min ?? '' }
						max={ max ?? '' }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
						style={ { minWidth: 50 } }
					/>
				</FlexItem>

				{ /* Border Bottom */ }
				<FlexItem>
					<NumberControl
						value={ sideBottom }
						onChange={ ( value ) =>
							updateBorders( value, 'sideBottom' )
						}
						min={ min ?? '' }
						max={ max ?? '' }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
						style={ { minWidth: 50 } }
					/>
				</FlexItem>

				{ /* Border Left */ }
				<FlexItem>
					<NumberControl
						value={ sideLeft }
						onChange={ ( value ) =>
							updateBorders( value, 'sideLeft' )
						}
						min={ min ?? '' }
						max={ max ?? '' }
						__next40pxDefaultSize
						__nextHasNoMarginBottom
						style={ { minWidth: 50 } }
					/>
				</FlexItem>

				{ /* Link/Unlink Button */ }
				<FlexItem className="shrink-0">
					<Button
						className="flex h-full"
						icon={ isLinked ? link : linkOff }
						isPressed={ isLinked }
						onClick={ () => setIsLinked( ! isLinked ) }
						title={
							isLinked
								? __( 'Unlink Borders', 'your-text-domain' )
								: __( 'Link Borders', 'your-text-domain' )
						}
					/>
				</FlexItem>
			</Flex>
			<Flex
				gap={ 0 }
				className="overflow-hidden justify-stretch text-center text-[10] text-gray-400"
				align="center"
			>
				<FlexItem className="flex-1">{ __( 'Top', 'alpha' ) }</FlexItem>
				<FlexItem className="flex-1">
					{ __( 'Right', 'alpha' ) }
				</FlexItem>
				<FlexItem className="flex-1">
					{ __( 'Bottom', 'alpha' ) }
				</FlexItem>
				<FlexItem className="flex-1">
					{ __( 'Left', 'alpha' ) }
				</FlexItem>
				<FlexItem className="flex-1"></FlexItem>
			</Flex>
		</BaseControl>
	);
};

InspectorFourDimension.borderRadius = AlphaFourDCss;

export default InspectorFourDimension;
